<template>
    <div class="container-fluid h-100">
        <div class="row justify-content-center h-100">
            <div class="default-page-width h-100">
                <div class="card card-default">
                    <div class="card-header">{{$t('privacypolicy.title')}}</div>
                    <div class="card-body">
                        <div>
                           <div v-if="$i18n.locale === 'de'">
                               <privacy-policy-de></privacy-policy-de>
                           </div>
                            <div v-else>
                                <privacy-policy-en></privacy-policy-en>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import PrivacyPolicyDe from "./privacy-policy-de.vue";
import PrivacyPolicyEn from "./privacy-policy-en.vue";

export default {
    name: "privacy-policy",
    props: ['reload', 'id'],
    components:{
        PrivacyPolicyEn,
        PrivacyPolicyDe
    },
    data: function(){
        return {
        }
    }
}
</script>

<style scoped>

</style>
